import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 165,
	height: 68,
	fill: "none",
	viewBox: "0 0 165 68",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#EC4949",
		fillRule: "evenodd",
		d: "M83.63 76.56c-32.22-1.4-93.78-13.32-82.2-49.8C13.01-9.72 38.75-.2 50.17 9.11c11.16 8.3 33.46 33.44 33.46 67.45Zm-10.4-11.32c-17.4-.75-46.06-5.93-39.8-25.34 4.08-12.67 18.9-5.16 21.12-3.38 6.87 5.52 13 12.67 18.69 28.72Z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#EC4949",
		fillRule: "evenodd",
		d: "M77 75.83C89.16 44 120.58-13.65 148.85 10.34c28.26 24 11.13 46.56-.97 54.85-11.12 8.36-40.88 22.18-70.9 10.64Zm12.31-7.14c6.17-16.08 27.63-38.48 39.34-31.44 12.69 7.63 4.62 20.18-1.57 24.34-5.7 4.2-22.31 13.04-37.77 7.1Z",
		clipRule: "evenodd"
	})]
});
const SvgRibbonBigTop = styled(base)({});
export default SvgRibbonBigTop;
